import { store, storeActions } from '~/utility/BinSentry-ui-utility';
import { LitEntity, html } from '../../utility/lit-entity';
import { BnModalMixin } from '../../common/bn-modal-mixin';
import '../actions/find-device';
import '../../common/bn-surface';
import '../../common/bn-flash';

class FindDeviceModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'find-device-modal';
  }

  renderContents() {
    return html`
      <style>
        #find-device-modal {
          --modal-min-width: 50%;
          --modal-min-height: 40%;
        }
      </style>
      <h3 slot="title">Find Device</h3>
      <find-device
        .href="${this.href}"
        @success="${this._onFindSuccess}"
      ></find-device>
    `;
  }

  _onFindSuccess(e) {
    const { entity } = e.detail;
    if (!entity) {
      return;
    }

    setTimeout(() => {
      this.close();
      store.dispatch(storeActions.navigate('/devices/show', { deviceId: entity.getLinkByRel('self').href }));
    }, 1000);
  }
}

window.customElements.define('find-device-modal', FindDeviceModal);
